import { useState } from "react";
import { faqs } from "../../mocks/chigua";

export default function FAQAccordion({ limit }: { limit?: number }) {
  const list = limit ? faqs.slice(0, limit) : faqs;
  const [open, setOpen] = useState<number | null>(0);

  return (
    <div className="flex flex-col gap-3">
      {list.map((item, i) => {
        const active = open === i;
        return (
          <div
            key={item.q}
            className={`overflow-hidden rounded-xl border transition ${
              active ? "border-primary-200 bg-background-50" : "border-background-200 bg-background-100/60"
            }`}
          >
            <button
              type="button"
              onClick={() => setOpen(active ? null : i)}
              aria-expanded={active}
              className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
            >
              <span className="flex items-center gap-3 text-sm font-semibold text-foreground-950 md:text-[15px]">
                <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-xs font-bold text-secondary-900">
                  {String(i + 1).padStart(2, "0")}
                </span>
                {item.q}
              </span>
              <span
                className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition ${
                  active ? "rotate-45 bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600"
                }`}
              >
                <i className="ri-add-line" aria-hidden="true" />
              </span>
            </button>
            <div className={`grid transition-all duration-300 ${active ? "grid-rows-[1fr]" : "grid-rows-[0fr]"}`}>
              <div className="overflow-hidden">
                <p className="px-5 pb-4 pl-[3.25rem] text-sm leading-relaxed text-foreground-600">{item.a}</p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}